<template>
  <div id="background" class="order-submit">
    <!-- //顶部导航栏 -->
    <van-nav-bar
      title="确认订单"
      left-arrow
      @click.native="$router.push('/cart')"
    ></van-nav-bar>
    <!-- //水平分割线 -->
    <div class="decorate"></div>
    <!-- //地址区域 -->
    <van-cell :to="{ path: '/address/list', query: $route.query }">
      <div class="flex area jc-sb aic">
        <van-icon name="location-o"></van-icon>
        <div class="flex2 jc-c ml-15 fg2">
          <p class="flex" v-if="addressInfo.name">
            <span class="custom-title">{{ addressInfo.name }}</span>
            <span class="custom-title">&nbsp;</span>
            <span class="custom-title">{{ addressInfo.tel }}</span>
          </p>
          <span class="custom-title fonts">{{
            addressInfo.address || "请选择地址"
          }}</span>
        </div>
        <van-icon class="f999" name="arrow" />
      </div>
    </van-cell>
    <div id="goods">
      <!-- //商品部分 -->
      <!-- //头部单元格 -->
      <van-cell-group>
        <van-cell
          :title="`运费${detail.expressFee / 100}元（满${
            detail.fullReduceMoney / 100
          }元免运费)`"
        />
      </van-cell-group>
      <van-card
        v-for="(item, index) in detail.carts"
        :key="index"
        :num="item.buyNum"
        :price="item.price | formatMoney"
        :desc="item.slaveName"
        title="A级-阳光冬枣（中）约2.6-3斤"
        :thumb="item.imgUrl"
      ></van-card>
      <!-- //尾部单元格 -->
      <van-cell-group>
        <van-cell
          title="商品总金额"
          :value="`¥${(detail.totalMoney / 100).toFixed(2)}`"
        />
      </van-cell-group>
      <van-cell-group>
        <van-cell title="运费" :value="`¥${detail.expressFee / 100}`" />
      </van-cell-group>
    </div>

    <div id="cell">
      <van-cell
        v-if="discount"
        title="优惠券"
        icon="coupon-o"
        value-class="red"
        :value="`¥${(discount / 100).toFixed(2)}`"
        is-link
        :to="`/order/coupon/${detail.totalMoney / 100}`"
      ></van-cell>
      <van-cell
        is-link
        :to="`/order/coupon/${detail.totalMoney / 100}`"
        title="优惠券"
        v-if="!discount"
        icon="comment-o"
        :value="`${detail.couponNum}张券可用`"
      ></van-cell>
      <van-cell icon="comment-o" value="0张券可用" is-link>
        <!-- 使用 title 插槽来自定义标题 -->
        <template slot="title">
          <span class="custom-title">苏打券</span>
        </template>
      </van-cell>
      <van-cell icon="gem-o" value is-link>
        <p class="flex jc-sb">
          <span class="custom-title">余额</span>
          <span class="custom-title red">¥0.00</span>
        </p>
      </van-cell>
      <van-cell icon="balance-list-o" value="不开发票" is-link>
        <!-- 使用 title 插槽来自定义标题 -->
        <template slot="title">
          <span class="custom-title">发票</span>
        </template>
      </van-cell>
    </div>

    <!-- 优惠券弹窗 -->

    <!-- 支付方式弹窗 -->
    <van-submit-bar
      :price="allFee"
      tip
      button-text="提交订单"
      @submit="onSubmit"
    />
    <van-action-sheet v-model="show" title="请选择支付方式">
      <PayWay @toPay="toPay" :allFee="allFee"></PayWay>
    </van-action-sheet>
  </div>
</template>

<script>
import PayWay from "./PayWay.vue";
export default {
  data() {
    return {
      orderId:'',
      // 选中的优惠券
      chosenCoupon: -1,
      // 显示优惠券列表
      showList: false,
      // 详情
      detail: {},
      show: false,
      // 支付信息
      payInfo: {},
    };
  },
  components: {
    PayWay,
  },

  created() {
    this.getDetail(this.preOrderId); 
  },

  computed: {
    // 总费用
    allFee() {
      let { expressFee, totalMoney } = this.detail;
      let discount = this.discount;
      let allFee = Number(expressFee) + Number(totalMoney) - Number(discount);
      return allFee;
    },
    // 地址
    addressInfo() {
      return this.$store.state.address.addressInfo;
    },

    couponNum() {
      return this.$store.state.coupon.couponNum;
    },
    // 优惠金额
    discount() {
      let discount = this.$store.state.coupon.discount;
      if (!discount) {
        return 0;
      } else {
        return discount;
      }
    },
    preOrderId() {
      return this.$route.query.preOrderId;
    },
  },

  methods: {
    // 支付
    // async onSubmit() {
    //   this.show = true;
    //   // 清除优惠券信息
    //   this.$store.commit("updateDiscount", 0);
    // },

    async onSubmit() { 
      try {
        let url = "/order/create";
        let data = {
          preOrderId: this.preOrderId,
          discount: this.discount,
          allFee: this.allFee,
          totalMoney: this.detail.totalMoney,
          addressInfo: this.addressInfo,
        };
        this.$loading(true);
        let res = await this.$post(url, data);
        this.payInfo = res.result;
        this.$loading(false);
        this.show = true;
        this.orderId = res.result.orderId;
        this.createWs();
      } catch (error) {
        this.$fail(error);
      }
    },

    toPay(payWay) {  
      // 将相关参数传到下一个页面
      let query = {
        payWay: payWay == 1 ? "wx" : "zfb",
        qrcode: this.payInfo.qrcode,
        orderId: this.payInfo.orderId,
        createTime: this.payInfo.createTime,
        allFee: this.allFee,
      };
      let url = "/order/pay";
      this.$post(url,query).then((res) => { 
        // this.$router.push({ path: "/order/pay", query:res.result });
      });
     
    },

    async getDetail(preOrderId) {
      let url = "/preOrder/detail";
      this.$loading(true);
      try {
        let res = await this.$get(url, { preOrderId });
        this.detail = res.result;
        this.$loading(false);
      } catch (error) {
        this.$fail(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },
    toAddressList() {
      this.$router.push({
        path: "/address/list",
        query: this.$route.query,
      });
    },

    // 创建 websocket
    createWs() {
      let env = process.env.NODE_ENV;
      let wsurl = env==='development'?'localhost:3003':'43.136.85.99:3003';
      var ws = new WebSocket(`ws://${wsurl}/ws?id=` + this.orderId);
      // 响应onmessage事件:
      ws.onmessage = (msg) => { 
        let data = JSON.parse(msg.data); 
        if (data.orderStatus) {
          if (data.orderStatus == '01') {
            this.$dialog
              .alert({
                message: "支付成功",
              })
              .then(() => {
                this.$router.push("/order/detail/"+this.orderId);
              });
          } else {
            this.$dialog
              .alert({
                message: "支付失败",
              })
              .then(() => {
                this.$router.push("/order/detail/"+this.orderId);
              });
          }
        }
      };
      ws.onopen = () => {
        // 给服务器发送一个字符串:
        ws.send("Hello!");
      };
    },
  },
};
</script>

<style lang="less">
@import "./index.less";
.order-submit {
  padding-bottom: 60px;
}
</style>